import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  Divider,
} from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export function IVR({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [ivrData, setIvrData] = useState({});
  const [ivrInst, setIvrInst] = useState("");
  const { ordNum } = useParams<{ ordNum: any }>();

  const getIVRData = async () => {
    try {
      setLoader(true);
      const { orderHours } = await fetchWrapper.get(
        `get-order-hours-for-vendor-portal-by-order-number/${ordNum}`
      );
      setIvrData(orderHours);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const getIVRInst = async () => {
    try {
      setLoader(true);
      const { clientInstruction } = await fetchWrapper.get(
        `get-client-instruction-by-ord-num/${ordNum}`
      );
      setIvrInst(clientInstruction);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  React.useEffect(() => {
    if (expand) {
      getIVRInst();
      getIVRData();
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(2)}>
          <Heading heading="IVR" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                <Box color="text.secondary" mb={1}>
                  <Typography className={classes.heading}>{"Instructions"}</Typography>
                  <Divider />
                </Box>

                <Typography
                  dangerouslySetInnerHTML={{
                    __html: ivrInst,
                  }}
                ></Typography>
                <Box color="text.secondary" mt={2}>
                  <Typography className={classes.heading}>{"Information"}</Typography>
                  <Divider />
                </Box>
                {Boolean(Object.keys(ivrData).length) ? (
                  Object.values(ivrData).map((item, i) => (
                    <Card key={i} index={i} ivrRowData={item} />
                  ))
                ) : (
                  <NoRecordFound />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
